import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "group"];

  filter(event) {
    const selectedTag = event.target.dataset.tag;
    // Remove gray and add primary to all buttons
    this.buttonTargets.forEach(btn => {
      btn.classList.remove('button--primary');
      btn.classList.add('button--gray');
    });
    // Toggle classes for the clicked button
    event.target.classList.remove('button--gray');
    event.target.classList.add('button--primary');

    this.groupTargets.forEach(group => {
      if (selectedTag === 'all' || group.dataset.tag === selectedTag) {
        group.removeAttribute('hidden');
      } else {
        group.setAttribute('hidden', '');
      }
    });
  }
}
